import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import StorePreviewCard from 'app/javascript/components/store/StorePreviewCard';
import { ROUTES } from 'app/javascript/constants/routes';
import { trackEvent } from 'app/javascript/firebase';
import { useStoreCatalog } from 'app/javascript/queries/useStoreCatalog';
import { previewStoreProducts } from 'app/javascript/data/storeCatalogs';

// Teaser of the academy store on the company page: a few products (one per
// category when possible) that all link through to the full store. Rendered
// only for academies the company payload flags with `has_store`, so the catalog
// fetch is expected to resolve; it renders nothing while loading or if empty.
export default function StorePreview({ slug }: { slug: string }) {
  const { data: catalog } = useStoreCatalog(slug);
  if (!catalog) return null;

  const products = previewStoreProducts(catalog, 3);
  if (products.length === 0) return null;

  return (
    <section>
      <div className="mb-6 flex items-baseline justify-between gap-4">
        <h2 className="font-bebas text-3xl uppercase tracking-[0.04em] text-foreground sm:text-4xl">Loja</h2>
        <Link
          to={ROUTES.COMPANY_STORE}
          params={{ slug }}
          onClick={() => trackEvent('store_preview_clicked', { company_slug: slug, target: 'see_all' })}
          className="inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.2em] text-yellow-400 transition-colors hover:text-yellow-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/50"
        >
          Ver loja completa
          <ArrowRight className="size-3.5" aria-hidden />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3">
        {products.map((product) => (
          <StorePreviewCard key={product.id} product={product} slug={slug} />
        ))}
      </div>
    </section>
  );
}
